// While no reachback review is pending or done. Once one is in progress or
// complete, the existing reachback messages take over.
const showWhileNoReview = (sample) =>
  (sample?.reachback?.status ?? "none") === "none";

// When each notice type is shown, as (sample, notice) => boolean. A type
// without an entry is always shown.
const VISIBILITY_RULES = {
  fluorescence: showWhileNoReview,
};
const DEFAULT_RULE = () => true;

/**
 * The customer notices to show as banners on a sample's results page, in
 * order; empty for none. `customerNotices` is set by the model function's
 * /predict (e.g. a fluorescence notice) and is absent on samples with
 * nothing to show. A notice without a message is skipped, and each type's
 * entry in VISIBILITY_RULES decides when it's shown.
 */
export function getBannerNotices(sample) {
  if (!Array.isArray(sample?.customerNotices)) return [];

  return sample.customerNotices.filter((notice) => {
    if (typeof notice?.message !== "string" || notice.message.trim() === "") {
      return false;
    }
    const isVisible = VISIBILITY_RULES[notice.type] ?? DEFAULT_RULE;
    return isVisible(sample, notice);
  });
}
